var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewSslCertificateFound = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5B66",
    d: "m7.55 19.365.075.077 6.205 3.66 6.097-3.668.073-.078c.41-.436.727-.94.94-1.483H6.59c.217.548.541 1.054.96 1.492M21.257 4.526c0-.562-.42-1.032-.978-1.095l-6.396-.722a1.2 1.2 0 0 0-.247 0l-6.395.722a1.1 1.1 0 0 0-.978 1.095v3.278h14.994zM23.748 9.364H3.866a.347.347 0 0 0-.347.346v6.256c0 .19.155.347.347.347h19.882a.347.347 0 0 0 .346-.347V9.71a.347.347 0 0 0-.346-.346M9.323 14.965c-.904 0-1.73-.445-1.736-1.446h.916c.024.488.41.711.856.711.283 0 .73-.114.73-.482 0-.795-2.37-.283-2.37-1.795 0-.844.784-1.242 1.531-1.242.844 0 1.603.374 1.633 1.308h-.874c-.047-.428-.295-.567-.747-.567-.253 0-.608.12-.608.429 0 .728 2.368.204 2.368 1.765 0 .964-.862 1.319-1.699 1.319m4.88 0c-.904 0-1.73-.445-1.735-1.446h.915c.025.488.41.711.856.711.283 0 .73-.114.73-.482 0-.795-2.37-.283-2.37-1.795 0-.844.784-1.242 1.531-1.242.845 0 1.604.374 1.633 1.308h-.873c-.048-.428-.295-.567-.748-.567-.252 0-.608.12-.608.429 0 .728 2.368.204 2.368 1.765 0 .964-.862 1.319-1.699 1.319m5.7-.096h-2.374V10.77h.904v3.278h1.47z"
  })));
};
export default SvgNewSslCertificateFound;